import React, { Component } from "react";
import "./App.css";
import "./normalize.css";
import Header from "./components/Header";
import Posts from "./components/Posts";
import Post from "./components/Post";
import NotFound from "./components/NotFound";
import PostForm from "./components/PostForm";
import Message from "./components/Message";
import Login from "./components/Login";
import VideoList from "./components/VideoList";
import Footer from "./components/Footer";
import firebase from "./firebase";
import SimpleStorage from "react-simple-storage";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

class App extends Component {
  state = {
    isAuthenticated: false,
    posts: [],
    message: null,
  };

  // Login Function
  onLogin = (email, password) => {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((user) => {
        this.setState({ isAuthenticated: true });
      })
      .catch((error) => console.error(error));
  };

  // Logout Function
  onLogout = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        this.setState({ isAuthenticated: false });
      })
      .catch((error) => console.error(error));
  };
  // set new slug by taking title and joining spaces with a '-'
  getNewSlugFromTitle = (title) =>
    encodeURIComponent(title.toLowerCase().split(" ").join("-"));

  // ADD--------------------------------------------------------------------------
  addNewPost = (post) => {
    // Create reference to firebase database
    const postsRef = firebase.database().ref("posts");
    post.slug = this.getNewSlugFromTitle(post.title);
    delete post.key;
    postsRef.push(post);
    this.setState({
      // Add new post to state posts and set message to saved
      message: "saved",
    });
    // Reset message to stop displaying, will cause Message component to unmount
    setTimeout(() => {
      this.setState({ message: null });
    }, 1600);
  };

  // UPDATE----------------------------------------------------------------------
  updatePost = (post) => {
    // Set new slug title
    post.slug = this.getNewSlugFromTitle(post.title);
    // Find the index of the first post that has the same slug
    const index = this.state.posts.findIndex((p) => p.id === post.id);
    // Use index to remove edited post from state and add the new post back in
    const posts = this.state.posts
      .slice(0, index)
      .concat(this.state.posts.slice(index + 1));
    // Add new post in and resort them
    const newPosts = [...posts, post].sort((a, b) => a.id - b.id);
    this.setState({
      posts: newPosts,
      message: "updated",
    });
    setTimeout(() => {
      this.setState({ message: null });
    }, 1600);
  };

  // DELETE--------------------------------------------------------------------
  deletePost = (post) => {
    if (window.confirm("Delete this post?")) {
      const posts = this.state.posts.filter((p) => p.id !== post.id);
      this.setState({ posts, message: "deleted" });
      setTimeout(() => {
        this.setState({ message: null });
      }, 1600);
    }
  };

  render() {
    return (
      <Router>
        <div className="App">
          <SimpleStorage parent={this} />

          <Header
            isAuthenticated={this.state.isAuthenticated}
            onLogout={this.onLogout}
          />

          {/* Render the state message and Message component if it is true */}
          {this.state.message && <Message type={this.state.message} />}

          <Switch>
            <Route
              // Displays the posts on the homepage, essentially renders Posts component on page
              exact
              path="/"
              render={() => (
                <Posts
                  isAuthenticated={this.state.isAuthenticated}
                  posts={this.state.posts}
                  deletePost={this.deletePost}
                />
              )}
            />

            <Route exact path="/episodes" render={() => <VideoList />} />

            <Route
              // Defining the path that will load Post component
              path="/post/:postSlug"
              // Checking to find the post that matches the url with match prop from React-Router
              render={(props) => {
                const post = this.state.posts.find(
                  (post) => post.slug === props.match.params.postSlug
                );
                // Once collected from state it will return the post prop in the Post component
                if (post) return <Post post={post} />;
                // If not found go to 404
                else return <NotFound />;
              }}
            />

            <Route
              exact
              path="/login"
              render={() =>
                !this.state.isAuthenticated ? (
                  <Login onLogin={this.onLogin} />
                ) : (
                  <Redirect to="/" />
                )
              }
            />

            <Route
              // To new post page (using PostForm component)
              exact
              path="/new"
              // pass addNewPost funtion as a prop
              render={() =>
                this.state.isAuthenticated ? (
                  <PostForm
                    addNewPost={this.addNewPost}
                    post={{ key: null, slug: "", title: "", content: "" }}
                  />
                ) : (
                  <Redirect to="/login" />
                )
              }
            />

            <Route
              // To edit page
              path="/edit/:postSlug"
              // Render props with slug
              render={(props) => {
                const post = this.state.posts.find(
                  (post) => post.slug === props.match.params.postSlug
                );
                // if there is a slug...move to the edit page
                if (post && this.state.isAuthenticated) {
                  return <PostForm updatePost={this.updatePost} post={post} />;
                  // Else redirect
                } else if (post && !this.state.isAuthenticated) {
                  return <Redirect to="/login" />;
                } else {
                  return <Redirect to="/" />;
                }
              }}
            />
            <Route component={NotFound} />
          </Switch>
        </div>
        <Footer />
      </Router>
    );
  }
}

export default App;
